/**
 * @module profile/components/brief/head_1_1
 */
import React, { Component, PropTypes } from 'react';
import partial from 'lodash/partial';
import NegotiationActions from 'project/components/brief/negotiation_actions_1_1';
import NegotiationModal from 'common/components/modal/negotiation';
import NEGOTIATION_STATUSES from 'project/statuses_1_1';
import { getDetailedCost } from 'pap/utils';
import { isCollaborator } from 'project/utils';
import { getTimeLeftLabel } from 'common/utils';
import { advanceNegotiationRequest } from 'project/ducks/project_1_1';
import Feedback from 'common/containers/project_feedback';
import Money from 'common/components/money';

/**
 * Project brief header for 1-1 projects.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class BriefHead1_1 extends Component {
  constructor(props) {
    super(props);

    this.handleActionClick = this.handleActionClick.bind(this);
    this.handleNegotiationDone = this.handleNegotiationDone.bind(this);
  }

  handleNegotiationDone() {
    /* fetch updated project and message stream */
    const { project, fetchProject, fetchMessagesIfNeeded } = this.props;

    fetchProject(project.id);

    if (project.message_stream_id) {
      fetchMessagesIfNeeded({
        streamId: project.message_stream_id,
        force: true,
        project
      });
    }
  }

  handleActionClick(action) {
    const { setNegotiationAction, showPaymentModal } = this.props

    /* show payment or negotiation modal depending on the action*/
    if (action.label == 'Pay Now') {
      showPaymentModal(true)
    } else {
      setNegotiationAction(action)
    }
  }

  renderActions(actions) {
    return (
      <NegotiationActions actions={actions} selectedCreative={this.props.selectedCreative}
          onClick={this.handleActionClick}/>)
  }

  render() {
    const { project, user, selectedCreative, setNegotiationAction,
            negotiationAction, fetchProject } = this.props;

    const negotiationStatus = project.one_to_one_negotiation_status
    const negotiationValue = parseFloat(project.one_to_one_negotiation_value)
    const status = NEGOTIATION_STATUSES(project)[negotiationStatus]

    const duration = getTimeLeftLabel(project.deadline)

    /* since 1-1 projects are not public, the user can only be
       - the owner
       - a collaborator
       - the selected creative */
    const isClient = project.client === user.id
    const isCreative = project.one_to_one_creative === user.id
    const isCollab = isCollaborator(project)

    /* determine which actions can be performed by the current user */
    let actions = []
    if ((status.actor == 'creative' && isCreative) || (status.actor == 'client' && isClient)) {
      actions = status.actions
    }

    const detailedCost = getDetailedCost(
      project.features, project.award_rules, {}, negotiationValue, project.billables, user,
      project.package_tips
    )

    const statusLabel = (
      typeof(status.label) == "string"? status.label : status.label(isClient, isCreative, isCollab)
    );

    const hideAward = [
      "not_started", "client_requested_quote", "client_declined", "creative_declined"
    ].includes(negotiationStatus);

    return (
      <div className="brief-header brief-header-1-1">
        <div className="row text-center">
          <ul className="large-16 column stats-block">
            {project.status === '1_1_negotiating' &&
            <li>
              <span className="brief-header-label">Offer Status</span>
              <span className="brief-header-stat">{ statusLabel }</span>
            </li>}
            <li>
              <span className="brief-header-label">
                Award
              </span>
              <span className="brief-header-stat">
                { hideAward ? 'TBD' : <Money value={negotiationValue} /> }
              </span>
            </li>
            {(isClient || isCollab) &&
            <li>
              <span className="brief-header-label">
                Total Cost
              </span>
              <span className="brief-header-stat">
                { hideAward? 'TBD' : <Money value={detailedCost.total} /> }
              </span>
            </li>}
            {isCreative &&
            <li>
              <span className="brief-header-label">
               Time Left
              </span>
              <span className="brief-header-stat">
                {duration}
              </span>
            </li>}
            {(isCreative && project.status !== '1_1_negotiating') &&
            <li>
              <span className="brief-header-label">
                Feedback
              </span>
              <span className="brief-header-stat">
                <Feedback project={project} showLabel={true}/>
              </span>
            </li>}
            { actions.length > 0 &&
            <li className="actions-container">
              <div className="negotiation-actions">
                { this.renderActions(actions) }
              </div>
            </li> }
          </ul>
        </div>

        <NegotiationModal action={negotiationAction}
          advanceRequest={partial(advanceNegotiationRequest, project.id)}
          onClose={partial(setNegotiationAction, null)}
          currentValue={parseFloat(project.one_to_one_negotiation_value || 0)}
          selectedCreative={selectedCreative}
          onDone={this.handleNegotiationDone}/>
      </div>
    );
  }
}

/**
 * PropTypes.
 *
 * @property {object} project - current project
 * @property {object} user - logged in user
 * @property {object} selectedCreative - selected creative
 * @property {object} negotiationAction - negotiation action being performed
 * @property {func} setNegotiationAction - set negotiation action to be performed
 * @property {func} showPaymentModal - show payment modal
 * @property {func} fetchProject - fetch a project by its ID
 * @property {func} fetchMessagesIfNeeded - fetch project messages
 */
BriefHead1_1.propTypes = {
  project: PropTypes.object,
  user: PropTypes.object,
  selectedCreative: PropTypes.object,
  negotiationAction: PropTypes.object,
  setNegotiationAction: PropTypes.func,
  showPaymentModal: PropTypes.func,
  fetchProject: PropTypes.func,
  fetchMessagesIfNeeded: PropTypes.func,
};



// WEBPACK FOOTER //
// ./project/components/brief/head_1_1.jsx